import { installDomRemovalDiagnostics } from './app/_components/domRemovalDiagnostics';

// Next loads this module before starting client hydration.
installDomRemovalDiagnostics();
